<template>
  <div>
    <div class="title">How is my monthly payment calculated?</div>
    <div class="payment">
      <div class="key"></div>
      <div class="pair">
        <div class="label">Principle &amp; Interest</div>
        <div class="value">{{this.FORMATED_PAYMENT_AND_EXTRA}}</div>
      </div>
    </div>
    <div class="insurance">
      <div class="key"></div>
      <InputField
        class="start-date input"
        label="Homeowner's Insurance"
        :value="FORMATED_INSURANCE_COST"
        target="INSURANCE_COST"
        :prefix="dollar"
        :update="update"
      />
    </div>
    <div class="tax">
      <div class="key"></div>
      <InputField
        class="tax input"
        label="Property Tax"
        :value="FORMATED_PROPERTY_TAX"
        target="PROPERTY_TAX"
        :prefix="dollar"
        :update="update"
      />
    </div>
    <div class="hoa">
      <div class="key"></div>
      <InputField
        class="hoa input"
        label="HOA Fees"
        :value="FORMATED_HOA"
        target="HOA_FEES"
        :prefix="dollar"
        :update="update"
      />
    </div>
    <div class="total">Total monthly payment = {{this.FORMATED_BREAKDOWN_PAYMENT}}</div>
  </div>
</template>
<script>
import InputField from "./util/InputField";
import { checkValidation } from "../util/validate";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import { roundCurrency, roundDollarsToCents } from "../util/bankersRound";
import dollar from "../../public/dollar-sign.svg";

const { UPDATE_INSURANCE_COST, UPDATE_HOA, UPDATE_PROPERTY_TAX } = ACTIONS;
const {
  FORMATED_INSURANCE_COST,
  FORMATED_PROPERTY_TAX,
  FORMATED_HOA,
  FORMATED_BREAKDOWN_PAYMENT,
  FORMATED_PAYMENT_AND_EXTRA
} = GETTERS;
const { CHANGE } = MUTATIONS;

export default {
  data() {
    return {
      dollar
    };
  },
  computed: {
    ...mapState({
      state: state => state.base
    }),
    ...mapGetters([
      FORMATED_PAYMENT_AND_EXTRA,
      FORMATED_BREAKDOWN_PAYMENT,
      FORMATED_INSURANCE_COST,
      FORMATED_HOA,
      FORMATED_PROPERTY_TAX
    ])
  },

  methods: {
    ...mapMutations({
      CHANGE
    }),
    ...mapActions({
      UPDATE_INSURANCE_COST,
      UPDATE_HOA,
      UPDATE_PROPERTY_TAX
    }),
    showValue(value, target, errorState) {
      if (
        typeof this.state.ERRORS["PAYOFF_ADJUSTMENTS_FORM"] !== "undefined" &&
        typeof this.state.ERRORS[target] !== "undefined"
      )
        return value;
      return typeof this.state.ERRORS[target] === "undefined" ||
        this.state.ERRORS[target].length === 0
        ? value
        : errorState;
    },
    update(e) {
      let target = e.target.parentNode.id;
      let value = e.target.value;
      value = roundDollarsToCents(value.replace(/[^0-9.-]/g, ""), 10);

      const valid = checkValidation({
        state: this.state,
        change: this.CHANGE,
        target,
        value
      });
      switch (target) {
        case "INSURANCE_COST":
          this.UPDATE_INSURANCE_COST({ target, value });
          break;
        case "PROPERTY_TAX":
          this.UPDATE_PROPERTY_TAX({ target, value });
          break;
        case "HOA_FEES":
          this.UPDATE_HOA({ target, value });
          break;
        default:
          this.CHANGE({ target, value });
      }
    }
  },
  components: {
    InputField
  }
};
</script>

<style lang="scss">
.payment-breakdown-adjustments {
  display: flex;
  flex-direction: column;
  justify-content: center;
  & > * {
    align-items: center;
    display: flex;
    height: 49px;
  }
  & > :not(:first-child) {
    border-top: 1px solid #e3e3e3;
  }
  & > :last-child {
    border-bottom: 1px solid #e3e3e3;
  }
  & .input-field .label {
    margin-left: 16px;
    width: calc(61% - 15px);
    margin-bottom: 0;
  }
  & .input-field input {
    text-align: right;
    padding-right: 11px;
    height: 30px;
    max-width: 141px;
    width: calc(30% - 11px);
  }
  & .input-field .error {
    font-size: 12px;
    color: red;
    width: 100% !important;
    top: 22px;
    left: 16px;
  }
  .pair {
    display: flex;
    text-align: right;
    height: 30px;
    justify-content: space-between;
  }
  .pair .label {
    margin-left: 16px;
    width: auto;
    margin-bottom: 0;
    color: #282828;
  }
  .pair .label,
  .pair .value {
    font-family: Open Sans, sans-serif;
    display: inherit;
    font-size: 14px;
  }
  .pair .value {
    color: #979797;
    justify-self: right;
    width: fit-content;
  }
  .input-field,
  .pair {
    position: relative;
    align-items: center;
    width: 100%;
  }
  .title,
  .total {
    font-family: Open Sans, sans-serif;
    color: #282828;
    width: 100%;
    font-weight: 700;
  }
  .title {
    font-size: 16px;
  }
  .total {
    justify-content: flex-end;
    font-size: 14px;
  }
  .key {
    height: 28px;
    width: 13px;
  }
  .payment {
    width: 100%;
  }
  .payment .key {
    background-color: #acd14d;
  }
  .insurance .key {
    background-color: #62c5b4;
  }
  .tax .key {
    background-color: #153763;
  }
  .hoa .key {
    background-color: #7b7b7b;
  }
}
</style>